// Vocabulary mirrors LibraryItemView's proto comment (item_type, status) —
// proto/mono/projectdata/v1/projectdata.proto.
export const ITEM_TYPES = [
    {
        value: 'evidence',
        label: 'Evidence'
    },
    {
        value: 'template',
        label: 'Template'
    },
    {
        value: 'proof_point',
        label: 'Proof point'
    },
    {
        value: 'narrative',
        label: 'Narrative'
    },
    {
        value: 'reference',
        label: 'Reference'
    },
    {
        value: 'asset',
        label: 'Asset'
    }
];
/** Item types that carry a file (attached on create). */ export const FILE_ITEM_TYPES = new Set([
    'template',
    'asset'
]);
/** What the file picker offers for a template: Office files and Office templates. */ export const TEMPLATE_ACCEPT = '.docx,.dotx,.xlsx,.xltx,.pptx,.potx';
// Statuses only shown for the My items scope filter — Discover results are
// always released (see libraryItemDenialReason), so a status filter would be
// decorative there.
export const STATUSES = [
    {
        value: 'draft',
        label: 'Draft'
    },
    {
        value: 'released',
        label: 'Released'
    },
    {
        value: 'withdrawn',
        label: 'Withdrawn'
    }
];
export function labelOf(options, value) {
    return options.find((o)=>o.value === value)?.label ?? value ?? '—';
}
// proto Timestamp -> short local date string, tolerant of an unset/invalid ts.
export function formatTs(ts) {
    if (!ts) return '—';
    try {
        return ts.toDate().toLocaleDateString();
    } catch  {
        return '—';
    }
}
export function parseDateInput(value) {
    if (!value) return null;
    const [y, m, d] = value.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
}
// SAD-460 Past Performance Reference vocabulary — proto/mono/projectdata/v1/past_performance.proto.
export const REFERENCE_ORIGINS = [
    {
        value: 'internal',
        label: 'Internal'
    },
    {
        value: 'partner',
        label: 'Partner'
    },
    {
        value: 'historical',
        label: 'Historical'
    }
];
export const BASIS_KINDS = [
    {
        value: 'customer_confirmation',
        label: 'Customer confirmation'
    },
    {
        value: 'partner_reply',
        label: 'Partner reply'
    },
    {
        value: 'archived_record',
        label: 'Archived record'
    },
    {
        value: 'delivery_interview',
        label: 'Delivery interview'
    },
    {
        value: 'program_derivative',
        label: 'Program derivative'
    },
    {
        value: 'manual_note',
        label: 'Manual note'
    }
];
/** Blank outcome/contact means "unknown" (stored NULL) — never invent one. */ export function orUnknown(value) {
    return value?.trim() ? value : 'Unknown';
}
export const EMPTY_REFERENCE_FORM = {
    origin: REFERENCE_ORIGINS[0].value,
    providerRole: '',
    limitations: '',
    basisKind: BASIS_KINDS[0].value,
    outcome: '',
    referenceContact: ''
};
/** Returns the reason a reference form cannot be submitted, or '' when it can. */ export function referenceFormError(form, providerCompanyId) {
    if (form.origin === 'partner' && !providerCompanyId) {
        return 'A partner reference needs a provider company.';
    }
    return '';
}
